var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center mb-4"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('h2', {
    style: {
      color: '#fff',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)'
    }
  }, [_vm._v(" " + _vm._s(_vm.tagline) + " ")])]), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card rounded-lg"
  }, [_c('div', {
    staticClass: "card-body pl-5 pr-5"
  }, [_c('h3', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t("forgotyourPassword")))]), _c('p', [_vm._v(_vm._s(_vm.$t("enterEmailPhone")))]), _c('form', {
    staticClass: "theme-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "input-label",
    attrs: {
      "for": "resetInput"
    }
  }, [_vm._v(_vm._s(_vm.$t("contactUs.email")))]), _c('v-text-field', {
    attrs: {
      "id": "resetInput",
      "placeholder": _vm.$t('contactUs.emailPlaceholder'),
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.text,
      callback: function ($$v) {
        _vm.text = $$v;
      },
      expression: "text"
    }
  })], 1), _c('div', {
    staticClass: "pt-4 form-group text-center"
  }, [!_vm.isLoading ? [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center flex-wrap gap-2"
  }, [_c('b-button', {
    staticClass: "btn-primary",
    attrs: {
      "size": "sm",
      "type": "submit"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("cart.continue")) + " ")]), _c('router-link', {
    staticClass: "modal-title-otp",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("returnLogin")) + " ")])], 1)] : _vm._e(), _vm.isLoading ? _vm._l(3, function (i) {
    return _c('b-spinner', {
      key: i,
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "label": "Small Spinner",
        "type": "grow"
      }
    });
  }) : _vm._e()], 2)])])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }